<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33301 5.16536H8.66634V6.4987H7.33301V5.16536ZM7.33301 7.83203H8.66634V11.832H7.33301V7.83203ZM7.99967 1.83203C4.31967 1.83203 1.33301 4.8187 1.33301 8.4987C1.33301 12.1787 4.31967 15.1654 7.99967 15.1654C11.6797 15.1654 14.6663 12.1787 14.6663 8.4987C14.6663 4.8187 11.6797 1.83203 7.99967 1.83203ZM7.99967 13.832C5.05967 13.832 2.66634 11.4387 2.66634 8.4987C2.66634 5.5587 5.05967 3.16536 7.99967 3.16536C10.9397 3.16536 13.333 5.5587 13.333 8.4987C13.333 11.4387 10.9397 13.832 7.99967 13.832Z"
      fill="#2A8176"
    />
  </svg>
</template>

<script>
export default {}
</script>

<style>
</style>
